var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: "100%", persistent: "", "max-width": "500" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("div", [_vm._v("Rename Application")]),
              _c("v-spacer"),
              _c(
                "v-icon",
                {
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("mdi-close")]
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "mt-3" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.nop.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.renameValid,
                    callback: function ($$v) {
                      _vm.renameValid = $$v
                    },
                    expression: "renameValid",
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "9" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              id: "appNameInput",
                              label: "Application name",
                              placeholder:
                                "Please provide the application name",
                              outlined: "",
                              rules: [
                                _vm.notEmpty,
                                _vm.min,
                                _vm.rules.validName,
                              ],
                              dense: "",
                              autocomplete: "new-password",
                              color: "#006c27",
                              "error-messages": _vm.serverErrorRename,
                            },
                            model: {
                              value: _vm.newName,
                              callback: function ($$v) {
                                _vm.newName = $$v
                              },
                              expression: "newName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text",
                              attrs: {
                                color: "#006c27",
                                id: "renameButton",
                                disabled: !_vm.renameValid,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.renameApplication()
                                },
                              },
                            },
                            [_vm._v(" Rename ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: {
            dark: false,
            absolute: true,
            value: _vm.renaming,
            opacity: "0.1",
          },
        },
        [
          _c(
            "v-container",
            { attrs: { "fill-height": "", fluid: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { align: "center", justify: "center" } },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          align: "center",
                          size: 120,
                          width: 13,
                          color: "#006c27",
                          indeterminate: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }